import { ASK_AI_ACCESS_FLAG_KEY } from '@tribeplatform/react-sdk/hooks'

export const EMAIL_DIGEST_ADDON_CATEGORY = 'emailDigestAccess'
export const JWT_SSO_ACCESS = 'jwtSSOAccess'
export const SAML_SSO_ACCESS = 'samlSSOAccess'
export const OAUTH2_SSO_ACCESS = 'oauth2SSOAccess'
export const CUSTOM_DOMAIN = 'customDomain'
export const TRANSLATION_LOCALE_CAPACITY = 'translationLocaleCapacity'
export const EMAIL_CUSTOMIZATION = 'emailCustomization'
export const ASK_AI_ACCESS = ASK_AI_ACCESS_FLAG_KEY
